import React from 'react'
import "./Prime.css"

function Prime() {
    return (
        <div>
           
            <img className="Primeimg" src=".\images\prime1.png"/>
            <img className="Primeimg" src=".\images\prime2.png"/>
            <img className="Primeimg" src=".\images\prime3.png"/>
        </div>
    )
}

export default Prime
